import Route from '@ember/routing/route';

export default class PlanningDashboardRoiRoute extends Route {}
